import { render, staticRenderFns } from "./Pos_invoices_tax_refund.vue?vue&type=template&id=0ec76159&scoped=true&"
import script from "./Pos_invoices_tax_refund.vue?vue&type=script&lang=js&"
export * from "./Pos_invoices_tax_refund.vue?vue&type=script&lang=js&"
import style0 from "./Pos_invoices_tax_refund.vue?vue&type=style&index=0&id=0ec76159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec76159",
  null
  
)

export default component.exports